import { createActions } from 'redux-actions';

export const { apiError, resetRedirect, redirectTo, setLocale } = createActions({
    API_ERROR: undefined,
    RESET_REDIRECT: undefined,
    REDIRECT_TO: undefined,
    SET_LOCALE: undefined,
});
